import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'GLI ESERCIZI CHE HAI MODIFICATO',
        description: 'Nei tuoi esercizi vedi subito anche il titolo e la difficoltà se li hai impostati.',
        isActive: true,
        name: 'UserExercisesPanel',
        tutorialName: 'crea-verifica_risultati-docente'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 35,
        yOffset: -160
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 20,
        yOffset: -165
    }
};
